/* Kolsyra team - hover-activated list with image swap.
 * Web Component <kolsyra-team> wraps a list of rows and a media column.
 * Hovering or focusing a row sets it active; image fades in via CSS.
 * Desktop only - mobile shows all members stacked (CSS @media handles it). */
(function () {
  'use strict';

  if (!('customElements' in window)) return;
  if (customElements.get('kolsyra-team')) return;

  class KolsyraTeam extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-team-row]'));
      this.images = Array.from(this.querySelectorAll('[data-team-image]'));
      if (this.rows.length === 0) return;

      this._onActivate = this._onActivate.bind(this);

      this.rows.forEach((row) => {
        row.addEventListener('mouseenter', this._onActivate);
        row.addEventListener('focusin', this._onActivate);
      });
    }

    disconnectedCallback() {
      this.rows.forEach((row) => {
        row.removeEventListener('mouseenter', this._onActivate);
        row.removeEventListener('focusin', this._onActivate);
      });
    }

    _onActivate(event) {
      const row = event.currentTarget;
      const idx = row.getAttribute('data-team-row');
      if (idx == null) return;
      this.activate(idx);
    }

    activate(idx) {
      this.rows.forEach((row) => {
        row.classList.toggle('is-active', row.getAttribute('data-team-row') === idx);
      });
      this.images.forEach((img) => {
        img.classList.toggle('is-active', img.getAttribute('data-team-image') === idx);
      });
    }
  }

  customElements.define('kolsyra-team', KolsyraTeam);
})();
